import { LambdaLogger } from "@sphtech/web2-logger";

// Initialize a global instance of LambdaLogger for structural logging across the application.
const logger = LambdaLogger.getInstance();

export default logger;
